<template>
    <b-dropdown  v-b-popover.hover.top="`Ver mais ações.`" size="sm" class="actions" variant="outline-secondary">
        <template #button-content>
            <i class="fas fa-ellipsis-v"></i>
        </template>
        <slot></slot>
    </b-dropdown>
</template>

<script>
export default {

}
</script>

